import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { carrierLoginAction } from '@mobile-dev/platform/common/redux/actions/CarrierLogin';
import NewBrandLogo from '../../assets/images/FreightSmith_LOGO_Final.png'
import { AppConstatnt } from '../../Utils/AppConstant';
import { isValidEmail, showAlert, stickyInfoAlert } from '../../Utils/Utility'
import { useHistory } from 'react-router';
import { clearError, clearResetPassword } from '@mobile-dev/platform/common/redux/actions/CommonAction';
import Auth from '@aws-amplify/auth';
import LoaderButton from '../Common/LoaderButton';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { injectIntl } from 'react-intl';

function CarrierLogin({ intl }) {

    const dispatch = useDispatch();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errormessage, setErrormessage] = useState(null)
    const [togglebutton, setTogglebutton] = useState(true)
    const [isValid, setValid] = useState(false);
    const history = useHistory();
    const carrierData = useSelector(state => state.carrierLogin);
    const { formatMessage } = intl;


    useEffect(() => {
        dispatch(clearError());
        dispatch(clearResetPassword());
    }, []);

    useEffect(() => {
        if (isValidEmail(email) && password.length > 0) {
            setTogglebutton(false)

        }
        else {
            setTogglebutton(true)

        }
    }, [email, password])

    const handleChange = (e) => {
        if (e.target.name === 'email') {
            setEmail(e.target.value);
        }
        else {
            setPassword(e.target.value);

        }
    }


    const validate = () => {
        if (isValidEmail(email) || email.length === 0) {
            setErrormessage(null)

        }
        else {
            setErrormessage("Email is Invalid")
        }
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(carrierLoginAction(email, password));
    }

    const signupToastWithLink = () => (
        <div>
            <p>{formatMessage({ id: 'app.not_Authorized_error' })}</p>
            <Link to="/signup">{formatMessage({ id: 'app.click_here' })}</Link>
        </div>
    );

    let jwtToken = null;
    if (carrierData?.session) {
        (async function token() {
            jwtToken = (await Auth.currentSession()).getIdToken().getJwtToken();

        })();
        history.push('/driverMobile');
    }
    else if (carrierData?.authPayload) {
        if (carrierData?.authPayload.error.message === 'Incorrect username or password.') {
            showAlert(toast.TYPE.ERROR, signupToastWithLink)
            dispatch(clearError());
        }
        else {
            switch (carrierData?.authPayload.nextAction) {
                case AppConstatnt.auth.OTP:
                    history.push({ pathname: '/Otp', state: { email: email, type: AppConstatnt.auth.OTP } });
                    return null;

                case AppConstatnt.auth.SIGNUPCONFIRM:
                    stickyInfoAlert(toast.TYPE.INFO, formatMessage({id:'app.carrier_email_Sent_info'}, { email: email }));
                    history.push({ pathname: '/Otp', state: { email: email, type: AppConstatnt.auth.SIGNUPCONFIRM } });
                    return null;

                default:
                    setErrormessage(carrierData.authPayload.error.message);
                    break;
            }
        }
    }


    return (
        <form className="form-signin" action="skip_1.html">
            <div className="card">

                <div className="card-header uc-blue"></div>

                <div className="card-header text-center bg-header">
                    <span className="text-dark-50 fa-lg">
                        <img className="img-fluid smith_logo" src={NewBrandLogo} alt="FrieghtSmith logo" />
                    </span>
                </div>
                <div className="card-body p-4">
                    <div className="text-center m-auto">
                        <h4 className="text-dark-50 text-center mt-0 font-weight-bold">{formatMessage({ id: "app.sign_in" })}</h4>
                        <p className="text-muted mb-4">{formatMessage({ id: "app.carrier_sign_in_content" })}</p>
                    </div>

                    <div className="form-label-group">
                        <input className="form-control" type="email" id="eMail" name="email" placeholder={formatMessage({ id: "app.email_address" })} onBlur={validate} onChange={handleChange} required autoFocus />
                        <label htmlFor="eMail" className="required">{formatMessage({ id: "app.email_address" })}</label>
                    </div>
                    {errormessage && <div className="error mb-2" style={{ color: "#f97474" }}>{errormessage}</div>}
                    <div className="form-label-group">
                        <input className="form-control" type="password" id="psword" name="password" placeholder="Password" onChange={handleChange} required />
                        <label htmlFor="psword" className="required">{formatMessage({ id: "app.password" })}</label>

                    </div>
                    <LoaderButton
                        valid={!togglebutton}
                        loading={carrierData.loading}
                        onButtonClick={handleSubmit}
                        name={formatMessage({ id: "app.sign_in" })}
                    />
                </div>


            </div>
            <div className="row">
                <div className="col-6 d-flex justify-content-start">
                    <small className="text-muted">{formatMessage({ id: "app.first_time_user" })}
                        <Link to='/Signup'>
                            <b className='text-orange ml-1'>{formatMessage({ id: "app.signup" })}</b>
                        </Link>
                    </small>
                </div>
                <div className="col-6 d-flex justify-content-end">
                    <small className="text-orange ml-1">
                        <Link to='/forgotpassword'>
                            <b className='text-orange ml-1'>{formatMessage({ id: "app.forgot_password" })}</b>
                        </Link>
                    </small>
                </div>
            </div>
            <div className="row mt-3">
                <h6 className="text-dark-50 text-center mt-0 mb-4"><span className="remaining_amt"> App Version {process.env.REACT_APP_VERSION}</span></h6>
            </div>
            {/* <div className="row mt-1">
                
            </div> */}
        </form>
    )
}

export default injectIntl(CarrierLogin);